import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { FiArrowRight, FiCheckCircle, FiMail } from 'react-icons/fi';
import api from '../axios';

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('Verifying your email...');

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token) {
      setStatus('error');
      setMessage('This verification link is missing a token.');
      return;
    }

    const verifyEmail = async () => {
      try {
        const response = await api.get(`/api/verify-email?token=${encodeURIComponent(token)}`);
        setStatus('success');
        setMessage(response.data?.message || 'Your email has been verified. You can now log in.');
      } catch (err) {
        const detail = err.response?.data?.detail || err.message || 'Verification failed.';
        setStatus('error');
        setMessage(detail);
      }
    };

    verifyEmail();
  }, [searchParams]);

  const isSuccess = status === 'success';

  return (
    <div className="min-h-screen overflow-hidden bg-[#07111a] text-white">
      <div className="fixed inset-0 -z-20 bg-[radial-gradient(circle_at_top_left,_rgba(27,186,123,0.16),_transparent_28%),radial-gradient(circle_at_80%_20%,_rgba(45,122,255,0.16),_transparent_30%),linear-gradient(180deg,_#09131d_0%,_#05080c_100%)]" />

      <div className="mx-auto flex min-h-screen max-w-3xl items-center px-4 pb-12 pt-28 sm:px-6 lg:px-8 lg:pt-32">
        <section className="w-full rounded-[2rem] border border-white/10 bg-white/5 p-8 shadow-[0_30px_80px_rgba(0,0,0,0.35)] backdrop-blur-xl sm:p-10">
          <div className="inline-flex items-center gap-2 rounded-full border border-emerald-400/25 bg-emerald-400/10 px-4 py-2 text-sm font-semibold text-emerald-200">
            {isSuccess ? <FiCheckCircle className="h-4 w-4" /> : <FiMail className="h-4 w-4" />}
            Email verification
          </div>

          <h1 className="mt-6 text-4xl font-black tracking-tight text-white sm:text-5xl">
            {status === 'loading' ? 'Confirming your email' : isSuccess ? 'Email verified' : 'Verification failed'}
          </h1>

          <p className="mt-6 text-lg leading-8 text-slate-300">
            {message}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/login"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-emerald-300 to-cyan-300 px-6 py-3 font-bold text-slate-950 transition hover:scale-[1.02]"
            >
              Go to login
              <FiArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to="/register"
              className="inline-flex items-center justify-center rounded-full border border-white/12 bg-white/5 px-6 py-3 font-semibold text-white transition hover:bg-white/10"
            >
              Back to registration
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
}

export default VerifyEmail;
